import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HashRouter } from 'react-router-dom'
import { readAndroidCssViewport } from "@/ui/androidViewport";
import { installAndroidPickImageCallback } from "@/lib/androidBridge";
import { installPagerBridge } from "@/lib/pagerBridge";
import './index.css'
import App from './App.tsx'

// --- stable viewport height polyfill (IME 올라올 때 레이아웃 축소 방지)
   function installStableVh() {
         let base = 0;
         let lastW = 0;
         const update = () => {
         const m = readAndroidCssViewport();
         const w = m?.cssW || document.documentElement.clientWidth || window.innerWidth || 0;
         const h = m?.cssH || document.documentElement.clientHeight || window.innerHeight || 0;
          // 화면 회전/폭 변경/더 큰 높이 관측 시에만 기준 높이 갱신
              if (!base || Math.abs(w - lastW) > 8 || h > base) {
                base = h; lastW = w;
              }
          const tag = document.activeElement?.tagName || '';
          const editing = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
          const shrunk = base - h > 80; // 키보드로 줄어든 것으로 간주하는 임계값
          const useH = (editing && shrunk) ? base : h;
          document.documentElement.style.setProperty('--app-lvh', `${useH}px`);
          };
         update();
         window.addEventListener('resize', update);
         window.addEventListener('orientationchange', update);
         window.addEventListener('focusin', update);
         window.addEventListener('focusout', () => setTimeout(update, 300));
       }
installStableVh();
installAndroidPickImageCallback();
installPagerBridge();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <HashRouter>
            <App />
        </HashRouter>
    </StrictMode>,
)

